import { useState } from "react";

const useActiveline = () => {
  const [stack, setStack] = useState("react");

  const setActiveLine = (arg) => {
    switch (arg) {
      case "html":
        setStack("html");
        break;
      case "css":
        setStack("css");
        break;
      case "js":
        setStack("js");
        break;
      case "ts":
        setStack("ts");
        break;
      case "react":
        setStack("react");
        break;
      case "firebase":
        setStack("firebase");
        break;
      case "mongodb":
        setStack("mongodb");
        break;
      case "nextJs":
        setStack("nextJs");
        break;
      case "gsap":
        setStack("gsap");
        break;
      case "tailwind":
        setStack("tailwind");
        break;

      default:
        break;
    }
  };
  return { stack, setActiveLine };
};

export default useActiveline;
